export default __webpack_public_path__ + "static/media/book-logo.df52bffa.svg";